import * as React from "react"
import {Box, Chip} from "@mui/material";


export default function RawMatcherImageComparisonModalCounter({ numOptions, localIndex }) {
	if (!numOptions)
		return <></>


	return <Box display="flex" justifyContent="center">
		<Chip
			size="small"
			color="default"
			label={`${(localIndex ?? 0) + 1} / ${numOptions}`}
			sx={{ height: 22 }}
		/>
	</Box>
}